// I campi anagrafici sul DB sono spesso null: concatenarli direttamente
// produce stringhe tipo "null null". Questi helper compongono solo i pezzi
// realmente presenti.

const pulisci = (valore) => {
  if (valore === null || valore === undefined) return '';
  const testo = String(valore).trim();
  return testo === 'null' ? '' : testo;
};

export function nomeCliente(cliente) {
  if (!cliente) return '';
  return [cliente.ragione, cliente.nome, cliente.cognome]
    .map(pulisci)
    .filter(Boolean)
    .join(' ');
}

export function componiIndirizzo(via, numciv, cap, comune, provincia) {
  const strada = [pulisci(via), pulisci(numciv)].filter(Boolean).join(', ');
  const citta = [pulisci(cap), pulisci(comune)].filter(Boolean).join(' ');
  const prov = pulisci(provincia);
  const parti = [strada, citta].filter(Boolean);
  let testo = parti.join(' - ');
  if (prov) testo += testo ? ` (${prov})` : `(${prov})`;
  return testo;
}
